import { render, staticRenderFns } from "./ProposalResponseMatrix.vue?vue&type=template&id=c08fe672&scoped=true"
import script from "./ProposalResponseMatrix.vue?vue&type=script&lang=ts"
export * from "./ProposalResponseMatrix.vue?vue&type=script&lang=ts"
import style0 from "./ProposalResponseMatrix.vue?vue&type=style&index=0&id=c08fe672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08fe672",
  null
  
)

export default component.exports